import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import ErrorPage from './ErrorPage'
import AppointmentPage from './AppointmentPage'
import AppointmentDetailsPage from './AppointmentDetailsPage'

const routes = [
  {
    path: '/',
    exact: true,
    component: AppointmentPage,
  },
  {
    path: '/appointment',
    component: AppointmentDetailsPage,
  },
  {
    path: '*',
    component: () => <ErrorPage is404 />,
  },
]

function Router() {
  return (
    <BrowserRouter>
      <Switch>
        {routes.map((route, index) => (
          <Route key={index} {...route} />
        ))}
      </Switch>
    </BrowserRouter>
  )
}

export default Router
